(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentahoyrealtimeDialogController', VentahoyrealtimeDialogController);

    VentahoyrealtimeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ventahoyrealtime'];

    function VentahoyrealtimeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ventahoyrealtime) {
        var vm = this;

        vm.ventahoyrealtime = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ventahoyrealtime.id !== null) {
                Ventahoyrealtime.update(vm.ventahoyrealtime, onSaveSuccess, onSaveError);
            } else {
                Ventahoyrealtime.save(vm.ventahoyrealtime, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ventahoyrealtimeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaproceso = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
